// CopiedItemForm.tsx component
// ListingCards componentから呼び出される。そのため、ListingCards componentから渡されたコピー元商品のIDをpropsとして受け取る。
// 受け取ったコピー元商品IDを使ってuseGetItemQueryによって商品情報を取得して、ItemForm componentを呼び出して、その中にコピー元商品の情報を入れる。

import { type GetItemQuery, useGetItemQuery } from "../graphql/generated/apollo";
import type { ItemImage } from "./ImageUploader";
import { ItemForm, type ItemType } from "./ItemForm";

type CopiedItemFormProps = {
  copiedItemId: string;
  inModal?: boolean;
};

export function CopiedItemForm({ copiedItemId, inModal }: CopiedItemFormProps) {
  const { data, loading, error } = useGetItemQuery({
    variables: { id: copiedItemId },
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const copiedItem = structuredClone(data?.items_by_pk);
  if (copiedItem) {
    // Transform GraphQL data to match ItemForm expectations
    const transformedItem: ItemType = {
      ...copiedItem,
      images: copiedItem.images.map(
        (image: NonNullable<GetItemQuery["items_by_pk"]>["images"][0]): ItemImage => ({
          // 新しい画像 (ただし参照先は同じ) として追加したいのでIDを新たに採番する
          id: window.crypto.randomUUID(),
          path: image.path,
          mime_type: image.mime_type,
        }),
      ),
      variants:
        copiedItem.variants?.map((variant: NonNullable<GetItemQuery["items_by_pk"]>["variants"][0]) => ({
          // NOTE: 作成時にIDを送らないため、ここでは元の値を入れても問題はない
          // TODO: 画像と統一したいが型を整理する必要あり
          id: variant.id,
          name: variant.name,
          stock_quantity: variant.stock_quantity,
          sku: variant.sku,
        })) ?? null,
    };
    return <ItemForm initialData={transformedItem} inModal={inModal} />;
  }

  return <ItemForm inModal={inModal} />;
}
